'use strict';

var chunk5WVHVQDL_js = require('../chunk-5WVHVQDL.js');
require('../chunk-3CUP7X6U.js');
var chunkHUKGHOBJ_js = require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var r = require('react');
var reactDom = require('react-dom');
var i = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var r__default = /*#__PURE__*/_interopDefault(r);
var i__default = /*#__PURE__*/_interopDefault(i);

var M=i__default.default.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: ${({$overlayColor:o})=>o};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`,k=i__default.default.div`
  height: ${({$height:o})=>o};
  width: ${({$width:o})=>o};
  position: relative;
  border-radius: ${({$borderRadius:o})=>`${o}`};
  padding: ${({$paddingHorizontal:o})=>o} ${({$paddingVertical:o})=>o};
  background-color: ${({$backgroundColor:o})=>o};
  max-height: ${({$maxHeight:o})=>o};
  max-width: ${({$maxWidth:o})=>o};
`,z=i__default.default.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`,C=i__default.default.button`
  position: absolute;
  height: ${({$size:o})=>o};
  width: ${({$size:o})=>o};
  padding: ${({$padding:o})=>o};
  border-radius: ${({$borderRadius:o})=>o};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: ${({$backgroundColor:o})=>o};
  top: -56px;
  right: 16px;
`,v=(o,d)=>{if(typeof window>"u")return null;let e=document.getElementById(d);return e||(e=document.createElement("div"),e.setAttribute("id",d),document.body.appendChild(e)),reactDom.createPortal(o,e)},j=({isOpen:o=!1,onClose:d,height:e="400px",overlayColor:f="var(--grey-alpha-600)",children:$,id:g="portal",width:m="300px",showCloseButton:y=!0,maxHeight:n="100%",maxWidth:l="100%",rounded:b=!0,defaultPadding:a=!0})=>{let{tokens:t}=chunkHUKGHOBJ_js.b(),[s,p]=r.useState(o||!1),_=()=>{p(!1),d==null||d(!1);};return r.useEffect(()=>{o!==s&&p(o);},[o]),v(s?r__default.default.createElement(M,{$overlayColor:f},r__default.default.createElement(k,{$paddingHorizontal:a?t.size_24:0,$paddingVertical:a?t.size_16:0,$height:e||"400px",$backgroundColor:t.background_fill_default_fill_primary,$borderRadius:b?t.corner_radius_16:t.corner_radius__0,$width:m||"300px",$maxHeight:typeof n=="number"?`${n}px`:n,$maxWidth:typeof l=="number"?`${l}px`:l},y&&r__default.default.createElement(C,{$size:t.icon_size_40,onClick:_,$padding:t.spacing_8,$backgroundColor:t.background_fill_default_fill_primary,$borderRadius:t.corner_radius_full},r__default.default.createElement(chunk5WVHVQDL_js.a,{size:t.icon_size_24})),r__default.default.createElement(z,null,$))):r__default.default.createElement(r__default.default.Fragment,null),g)};

exports.Modal = j;
